export default __webpack_public_path__ + "static/media/calendar.721ff41d.svg";